var _path, _path2, _g, _path3, _g2, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1493_3231)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.614 70.3348C104.15 70.3348 110.688 28.7839 79.7387 18.4277C48.7889 8.07158 14.642 42.8167 21.5012 77.8421C26.2102 101.887 47.1935 123.455 82.8264 131.032C100.338 134.756 151.479 135.193 164.176 127.308C190.169 111.165 182.362 70.3348 137.614 70.3348Z",
    fill: "#F3EBDE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1493_3231)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1493_3231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 38,
    width: 120,
    height: 96
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.213 41.7239C104.577 38.0707 109.922 38.0707 112.287 41.7239L165.845 124.475C168.429 128.467 165.564 133.735 160.808 133.735H53.6913C48.9359 133.735 46.0704 128.467 48.6542 124.475L102.213 41.7239Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1493_3231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.213 41.7239C104.577 38.0707 109.922 38.0707 112.287 41.7239L165.845 124.475C168.429 128.467 165.564 133.735 160.808 133.735H53.6913C48.9359 133.735 46.0704 128.467 48.6542 124.475L102.213 41.7239Z",
    fill: "#CFAE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.689 71.0704C136.689 71.8477 135.847 72.3329 135.175 71.9431C133.709 71.0935 131.33 71.0935 129.864 71.9431L128.35 72.8209L126.835 73.6987C125.369 74.5483 122.99 74.5483 121.524 73.6987L120.01 72.8209L118.495 71.9431C117.029 71.0935 114.65 71.0935 113.184 71.9431L111.67 72.8209L110.155 73.6987C108.689 74.5483 106.31 74.5483 104.844 73.6987L103.33 72.8209L101.815 71.9431C100.349 71.0935 97.9704 71.0935 96.5043 71.9431L94.9898 72.8209L93.4752 73.6987C92.0092 74.5483 89.6305 74.5483 88.1644 73.6987L86.6499 72.8209L85.1353 71.9431C83.6693 71.0935 81.2905 71.0935 79.8245 71.9431L78.2991 72.8209L76.7846 73.6987C75.3185 74.5483 72.9398 74.5483 71.4738 73.6987C70.5363 73.1554 69.9592 72.1539 69.9592 71.0704L69.9592 39.9432C69.9592 36.6295 72.6455 33.9432 75.9592 33.9432L130.689 33.9432C134.003 33.9432 136.689 36.6295 136.689 39.9432L136.689 71.0704Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1493_3231)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1493_3231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 69,
    width: 82,
    height: 65
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6519 71.3346C67.6223 68.2902 72.0766 68.2902 74.047 71.3346L109.455 126.042C111.608 129.369 109.22 133.759 105.258 133.759H34.4413C30.4785 133.759 28.0906 129.369 30.2437 126.042L65.6519 71.3346Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1493_3231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6519 71.3346C67.6223 68.2902 72.0766 68.2902 74.047 71.3346L109.455 126.042C111.608 129.369 109.22 133.759 105.258 133.759H34.4413C30.4785 133.759 28.0906 129.369 30.2437 126.042L65.6519 71.3346Z",
    fill: "#E6D3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1787 90.4868C90.1787 91.0235 89.5972 91.3586 89.1329 91.0894C88.1205 90.5027 86.478 90.5027 85.4656 91.0894L84.4198 91.6956L83.374 92.3017C82.3616 92.8884 80.719 92.8884 79.7067 92.3017L78.6609 91.6956L77.615 91.0894C76.6027 90.5027 74.9601 90.5027 73.9478 91.0894L72.902 91.6956L71.8561 92.3017C70.8438 92.8884 69.2012 92.8884 68.1889 92.3017L67.143 91.6955L66.0972 91.0894C65.0849 90.5027 63.4423 90.5027 62.43 91.0894L61.3841 91.6955L60.3383 92.3017C59.3259 92.8884 57.6834 92.8884 56.671 92.3017L55.6252 91.6955L54.5794 91.0894C53.567 90.5027 51.9245 90.5027 50.9121 91.0894L49.8588 91.6955L48.813 92.3017C47.8007 92.8884 46.1581 92.8884 45.1458 92.3017C44.4984 91.9265 44.0999 91.235 44.0999 90.4868L44.0999 69.8496C44.0999 67.0881 46.3385 64.8496 49.0999 64.8496L85.1787 64.8496C87.9401 64.8496 90.1787 67.0881 90.1787 69.8496L90.1787 90.4868Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.874 59.8124C137.202 58.9946 136.311 58.4023 135.317 58.1157C135.394 57.6915 135.434 57.2597 135.434 56.8279C135.434 52.7543 132.114 49.4526 128.016 49.4526C124.98 49.4182 122.23 51.3251 121.075 54.2637C120.407 53.8663 119.651 53.6638 118.884 53.6714C117.623 53.6485 116.422 54.2255 115.614 55.2382C115.147 55.8382 114.888 56.5872 114.884 57.3591C114.895 57.768 114.975 58.173 115.129 58.5514C113.635 59.3118 112.667 60.8748 112.619 62.6097C112.634 63.9013 113.182 65.1242 114.124 65.9611C114.614 66.412 115.183 66.7597 115.797 66.9928C116.425 67.2336 117.086 67.352 117.755 67.352H133.736C136.57 67.3635 138.872 65.2388 138.872 62.6097C138.864 61.5855 138.51 60.592 137.874 59.8124Z",
    fill: "#E6D3BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9456 83.9938C50.3957 83.3396 49.6665 82.8657 48.8536 82.6364C48.9164 82.2971 48.9492 81.9516 48.9492 81.6062C48.9492 78.3473 46.2326 75.7059 42.8793 75.7059C40.3958 75.6784 38.1453 77.2039 37.2009 79.5548C36.654 79.2369 36.0353 79.0749 35.4077 79.081C34.3767 79.0626 33.3934 79.5243 32.7329 80.3344C32.3504 80.8144 32.1382 81.4136 32.1352 82.0311C32.1441 82.3582 32.2099 82.6823 32.3354 82.9849C31.1131 83.5933 30.3211 84.8437 30.2822 86.2316C30.2942 87.2649 30.7425 88.2432 31.5135 88.9127C31.914 89.2734 32.3802 89.5516 32.8823 89.7381C33.3964 89.9307 33.9373 90.0255 34.4842 90.0255H47.5595C49.8787 90.0346 51.7615 88.3349 51.7615 86.2316C51.7556 85.4123 51.4657 84.6174 50.9456 83.9938Z",
    fill: "#E6D3BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1493_3231",
    x: 47.6816,
    y: 38.9839,
    width: 119.137,
    height: 94.7515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.756863 0 0 0 0 0.615686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1493_3231"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1493_3231",
    x: 29.4326,
    y: 69.0513,
    width: 80.833,
    height: 64.708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.756863 0 0 0 0 0.615686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1493_3231"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1493_3231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon3);
export default __webpack_public_path__ + "static/media/serviceIcon_3.d63411ed8c64d9101a51c328490920a3.svg";
export { ForwardRef as ReactComponent };